import { useEffect, useState } from "react";
import Link from "next/link";
import { useFormContext } from "./FormContext";
import { countryOptions } from "@/config/countries";

const BuyerEligibility = ({ showStep1 }) => {
  const { state, dispatch } = useFormContext();
  const { formData } = state;
  const [buyerName, setBuyerName] = useState(formData?.buyerName || "");
  const [country, setCountry] = useState(formData?.country || "");
  const [allFieldsError, setAllFieldsError] = useState(false);

  const handleCountryChange = (e) => {
    setCountry(e.target.value); 
  };
  useEffect(()=>{
    if(buyerName && country){
      setAllFieldsError(false)
    }
  },[buyerName,country])

  const handleNext = () => {
    if (buyerName && country) {
      setAllFieldsError(false);
      if (state.step === 1) {
        showStep1(true);
      }
      dispatch({
        type: "UPDATE_FORM_DATA",
        payload: {
          buyerName: buyerName,
          country: country,
        },
      });
      dispatch({
        type: "NEXT_STEP",
        payload: {
          buyerName: buyerName,
          country: country,
        },
      });
    } else {
      setAllFieldsError(true);
    }
  };

  return (
    <div className="min-h-[470px] mx-auto py-4 px-3 sm:px-2 bg-white rounded-[20px] shadow-xl border border-bordercolor">
      <h2 className="text-textxl sm:text-base2 font-medium mb-xsp text-center text-[#2C2C2C]">
      Check Your Buyer Credit Worthiness
      </h2>
      <p className="text-[#3C3C3C] text-center text-base2 sm:text-sm mb-4">
        Add a buyer and confirm their eligibility within 2 minutes.
      </p>

      <div className="mt-2">
        <div>
          <label className="block text-sm font-medium">Full Name*</label>
          <input
            onChange={(e) => setBuyerName(e.target.value)}
            value={buyerName}
            type="text"
            name="Name"
            id="Name"
            placeholder="Enter buyer’s name"
            className="block w-full mt-1 text-base flex-1 pl-2 h-6 rounded-md border-0 py-1.5 ring-1 ring-inset ring-bordercolor focus:ring-[#555] focus:outline-none"
          />
        </div>
        <div className="mt-2">
          <label className="block text-sm font-medium">Country*</label>
          <select
            className="block w-full mt-1 text-base flex-1 pl-2 h-6 rounded-md border-0 py-1.5 ring-1 ring-inset ring-bordercolor focus:ring-[#555] focus:outline-none"
            onChange={handleCountryChange}
            value={country}
          >
            <option value='' disabled>Select</option>
            {countryOptions.map((countryName, index) => (
              <option key={index} value={countryName}>
                {countryName}
              </option>
            ))}
          </select>
        </div>

        <p className="text-sm text-[#979797] text-center font-normal mt-3">
          By proceeding ahead, you agree to the{" "}
          <Link href="/terms-and-conditions" className=" text-[#086AC9]">
            Terms & Conditions
          </Link>{" "}
        </p>
        <div className="flex justify-center items-center mt-2">
          <button
            className="flex gap-x-1 justify-center py-2 w-1/2 text-center rounded-md text-white text-base font-medium bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]"
            onClick={handleNext}
          >
            Continue
            <svg
              xmlns="https://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="brand"
              width="24"
              height="24"
              className="fill-current text-white"
            >
              <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
            </svg>
          </button>
        </div>
        {allFieldsError && (
          <p className="text-progressColor4 text-xs mt-0.5">
            Please fill in all required fields.
          </p>
        )}
      </div>
    </div>
  );
};

export default BuyerEligibility;
